/**
 * useAuth — Hook to access the auth context.
 */

import { useContext } from 'react';
import { AuthContext } from './auth.context';
import type { AuthContextValue } from './auth.types';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}

export default useAuth;